import config from '../../../config'

export const isEnabled = feature =>
  !!config?.features[feature] || localStorage.getItem(feature) === 'true'

export const isDisabled = feature =>
  feature && config.features[feature] === false

export const isEnabledForValue = (feature, id) =>
  (id &&
    feature &&
    config.features &&
    config.features[feature] &&
    config.features[feature].includes(id)) ||
  false

export const isEnabledForStoreOrRepresentativeId = (
  feature,
  storeId,
  representativeId,
) =>
  isEnabledForValue(feature, storeId) ||
  isEnabledForValue(feature, representativeId)

export const Features = {
  VIRTUAL_CARD: 'virtualCard',
  DIGITAL_AGREEMENT: 'digitalAgreement',
  CART_ITEM_MERGE: 'cartItemMerge',
  SEND_CUSTOMER_FORM: 'sendCustomerForm',
  INCIDENT_NOTIFICATION: 'incidentNotification',
  FILTER_NOTIFICATION: 'filterNotification',
  USER_EXPORT: 'userExport',
  NEW_BONUS_API: 'newBonusApi',
  ACTIVATED_REPRESENTATIVES_FOR_DELAYED_PAYMENT:
    'activatedRepresentativesForDelayedPayment',
  ACTIVATED_STORES_FOR_DELAYED_PAYMENT: 'activatedStoresForDelayedPayment',
  ACTIVATED_COUNTRIES_FOR_DELAYED_PAYMENT:
    'activatedCountriesForDelayedPayment',
  ACTIVATED_STORES_FOR_RECONCILIATION: 'activatedStoresForReconciliation',
  ACTIVATED_COUNTRIES_FOR_PUSH_OUT: 'activatedCountriesForPushOut',
  RECONCILIATION: 'reconciliation',
  PAYMENT_MANAGEMENT: 'paymentManagement',
  ACTIVATED_REPRESENTATIVES_FOR_PAYMENT_MANAGEMENT_MODULE:
    'activatedRepresentativesForPaymentManagementModule',
  ACTIVATED_CHAT_DK: 'activatedChatDk',
}
